import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

// Utility function to format currency based on locale
export const formatCurrency = (amount, currency, colored = false) => {
    if (amount === null || amount === undefined) return '';

    // Check for negative amount
    const isNegative = amount < 0;
    const absoluteAmount = Math.abs(amount);

    // Convert to string and remove non-numeric characters (except comma and period)
    const numberString = absoluteAmount.toString().replace(/[^,\d]/g, '');
    const split = numberString.split(',');
    const rest = split[0].length % 3;
    let formatted = split[0].substr(0, rest);
    const thousand = split[0].substr(rest).match(/\d{3}/g);

    if (thousand) {
        const separator = rest ? '.' : '';
        formatted += separator + thousand.join('.');
    }

    formatted = split[1] !== undefined ? formatted + ',' + split[1] : formatted;

    // Add currency symbol
    switch (currency) {
        case 'IDR':
            formatted = `Rp ${formatted}`;
            break;
        case 'MYR':
            formatted = `RM ${formatted}`;
            break;
        case 'USD':
            formatted = `$ ${formatted}`;
            break;
        default:
            break;
    }

    if (colored) {
        return {
            text: isNegative ? `-${formatted}` : formatted,
            isNegative,
        };        
    }
    
    
    return isNegative ? `-${formatted}` : formatted;
    
};

// Fungsi untuk menghapus format mata uang dan mengembalikan nilai angka
const removeCurrency = (currency) => {
    return (amount) => {
        return amount.replace(/Rp|RM|\$/g, '').replace(/\./g, '').replace(',', '.');
    };
};

const CurrencyInput = ({ value, onChange, currency, placeholder, ...props }) => {
    const [inputValue, setInputValue] = useState(formatCurrency(value, currency));

    useEffect(() => {
        setInputValue(formatCurrency(value, currency));
    }, [value, currency]);

    const handleChange = (event) => {
        const rawValue = event.target.value;
        const numericValue = parseFloat(removeCurrency(currency)(rawValue)) || 0;
        setInputValue(formatCurrency(numericValue, currency));
        onChange(numericValue);
    };

    return (
        <input
            type="text"
            value={inputValue}
            onChange={handleChange}
            placeholder={placeholder}
            {...props}
        />        
    );
};

CurrencyInput.propTypes = {
    value: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    currency: PropTypes.oneOf(['IDR', 'MYR', 'USD']).isRequired,
    placeholder: PropTypes.string
};

export default CurrencyInput;
